<h1 mat-dialog-title>{{ 'DOCUMENT.DIALOG_TITLE' | translate }}</h1>

<mat-dialog-content style="padding-bottom: 10px">
  <form [formGroup]="clientForm">
    <div fxLayout="row" fxLayoutGap="10px">
      <mat-form-field fxFlex>
        <mat-label>{{ 'DOCUMENT.SEARCH_CLIENTS' | translate }}</mat-label>
        <input [matAutocomplete]="auto" formControlName="clientPicker" id="clientPicker" matInput type="text" />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="autocompleteSelect($event)"
          [displayWith]="autocompleteDisplay"
        >
          <mat-option *ngFor="let debtor of filteredClients" [value]="debtor">
            {{ autocompleteDisplay(debtor) }}
          </mat-option>
        </mat-autocomplete>
        <button (click)="resetDebtorForm()" mat-icon-button matSuffix>
          <mat-icon style="height: 24px; width: 24px">close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    <span>{{ 'DOCUMENT.CANCEL' | translate }}</span>
  </button>

  <button mat-button color="accent" type="submit" [disabled]="!selectedDebtorId" (click)="onSubmit()">
    <span>{{ 'DOCUMENT.SAVE' | translate }}</span>
  </button>
</mat-dialog-actions>
